module.exports = __webpack_public_path__ + "img/ball_ethgame.0dea5000.png";